import React from 'react';
import t from '../../translate';
import { getText } from '../panels/text/';
import logo from '../../../images/logo_moodlift.png';
import flag_en from '../../../images/language-switch-flag-en.png';
import flag_nl from '../../../images/language-switch-flag-nl.png';

//Programma-specifieke landingpagina (tussenstap tussen programma-keuze en
//het registratieformulier). Gebaseerd op de oude registration/_archive/
//panels/step2.js — toont titel, omschrijving, afbeelding, reviews en media.
//Tekstdata komt uit registrationTexts.panel2.interventions[<id>]; valt
//terug op getText() / intervention.image als de DB nog geen content heeft.
const EduLanding = ({
  intervention,
  interventionTexts,
  language_id,
  setLanguageId,
  onContinue,
  onBack,
}) => {
  const lang = language_id === 1 ? 'nl' : 'eng'; //registrationtexts gebruikt 'eng', niet 'en'

  const title =
    (interventionTexts && interventionTexts.title && interventionTexts.title[lang]) ||
    (intervention && intervention.title) ||
    '';

  const description =
    (interventionTexts && interventionTexts.description && interventionTexts.description[lang]) ||
    getText(intervention.id, 'description_part1') ||
    '';

  const buttonLabel =
    (interventionTexts && interventionTexts.button && interventionTexts.button[lang]) ||
    (language_id === 1 ? 'Schrijf je in' : 'Sign up');

  const reviewsTitle =
    (interventionTexts && interventionTexts.studentsReviewsTitle && interventionTexts.studentsReviewsTitle[lang]) || '';
  const reviewsContent =
    (interventionTexts && interventionTexts.studentsReviewsContent) || [];

  const mediaTitle =
    (interventionTexts && interventionTexts.mediaTitle && interventionTexts.mediaTitle[lang]) || '';
  const mediaContent =
    (interventionTexts && interventionTexts.mediaContent) || [];

  return (
    <div className="registrationContainer">
      <div className="step2">
        <header>
          <button type="button" className="btn prev" onClick={onBack}>
            {language_id === 1 ? "Terug naar alle programma's" : 'Back to all programmes'}
          </button>
          <a className="btn login" href="/">{t('Log in')}</a>
          <div className="languageswitchheader" onClick={() => setLanguageId(language_id === 1 ? 2 : 1)}>
            <div className={language_id === 1 ? 'code active' : 'code pointer'}> NL <img src={flag_nl} style={{height: '20px'}} alt="NL" /> </div>
            <div className={language_id === 2 ? 'code active' : 'code pointer'}> EN <img src={flag_en} style={{height: '20px'}} alt="EN" /> </div>
          </div>
        </header>

        <div className="container">
          <h1>{title}</h1>

          {description ?
            <div className="intervention-description" dangerouslySetInnerHTML={{__html: description}} />
            : <></>
          }

          {intervention.image ?
            <div className="intervention-image">
              <img src={intervention.image} alt={intervention.title} />
            </div>
            : <></>
          }

          <br /><br />

          <button type="button" className="btn btn-primary next" onClick={onContinue}>
            {buttonLabel}
          </button>

          {reviewsContent.length > 0 ?
            <>
              <br /><br /><br /><br />
              {reviewsTitle ? <h2>{reviewsTitle}</h2> : <></>}
              <div className="student-reviews">
                {reviewsContent.map((review, key) => (
                  <div key={key} className="student-review" dangerouslySetInnerHTML={{__html: review[lang] || ''}} />
                ))}
              </div>
            </>
            : <></>
          }

          {mediaContent.length > 0 ?
            <>
              <br /><br />
              {mediaTitle ? <h2>{mediaTitle}</h2> : <></>}
              <div>
                {mediaContent.map((item, key) => {
                  if (item.type === 'youtube') {
                    return (
                      <div className="youtube-container" key={key} style={{marginBottom: '40px'}}>
                        <iframe src={'https://www.youtube-nocookie.com/embed/' + item[lang]} title="YouTube video player" frameBorder="0" allowFullScreen></iframe>
                      </div>
                    );
                  }
                  return <img src={item[lang]} key={key} className="step2Image" alt="" />;
                })}
              </div>
            </>
            : <></>
          }
        </div>
      </div>
    </div>
  );
};

export default EduLanding;
